<template>
  <div>
    <CRow class="mb-4">
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span class="font-weight-bold h6"><CIcon name="cil-layers" size="lg"/> {{ caption }}</span>
            <div class="card-header-actions">
              <CButton  class="ml-2 " size="sm" color="light" shape="pill" variant="outline" @click="onReload">
                <span class="font-weight-bold " v-c-tooltip.hover.click="'Reload'"><CIcon name="cil-reload" /></span>
              </CButton>
            </div>
          </CCardHeader>
          <CCardBody>
            <CTabs add-tab-classes="mt-1">
              <CTab v-for="(objs,index) in item" :key="activityTabKey(objs, index)">
                <template slot="title">
                  <CIcon name="cil-calculator"/> {{objs.title}}
                </template>
                <CCardBody>
                  <Timeline v-if="objs.historys.length > 0 && index === 0" :key="timelineKey(objs, index)" :objs="objs"/>
                  <History :key="historyKey(objs, index)" :item="objs.historys" :fields="objs.fields" @info="yourself" />
                </CCardBody>
              </CTab>

            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import History from "@/projects/views/E-Performances/Estimate/components/Historys";
import Timeline from "@/projects/views/E-Performances/Estimate/component/Timeline.vue";

export default {
  name: 'Activitys',
  components: {Timeline, History, Multiselect},
  props: {
    caption: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    },
    item:{
      type: Array,
      default() {
        return []
      }
    }
  },
  data: function () {
    return {

    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      // this.$store.dispatch("affiliation/config",{})

    },

    activityTabKey(item, index) {
      return `${item && (item.id || item._id || item.type || item.title) ? (item.id || item._id || item.type || item.title) : 'tab'}-${index}`;
    },

    timelineKey(item, index) {
      const history = item && Array.isArray(item.historys) ? item.historys : []
      const value = history[0] && history[0].value ? history[0].value : {}
      const statusParts = []

      const appendStatus = (statuses) => {
        if (!Array.isArray(statuses) || statuses.length === 0) {
          return
        }

        const latest = statuses[statuses.length - 1] || {}
        const state = latest.state || {}
        statusParts.push([
          state._id || '',
          latest.timeStamp || latest.updatedAt || latest.createdAt || ''
        ].join(':'))
      }

      appendStatus(value.status)

      const structure = Array.isArray(value.structure) ? value.structure : []
      const firstStructure = structure[0] || {}
      appendStatus(firstStructure.status)

      if (firstStructure.children) {
        appendStatus(firstStructure.children.status)
      }

      return `timeline-${index}-${value._id || ''}-${statusParts.join('|')}`
    },

    historyKey(item, index) {
      const history = item && Array.isArray(item.historys) ? item.historys : []
      const version = item && item.historyVersion ? item.historyVersion : 0

      return `history-${index}-${version}-${history.length}`
    },

    yourself(item){
      // item.type = this.item.type
      this.$emit('info',item)
    },

    onReload(){
      this.$emit("reload",{})
    }

  },


  computed: {
    ...mapGetters({
      objsLang: "setting/lang",
    }),
  },

  watch: {

  }

}
</script>
<style>


</style>
